import { RootState } from '../rootReducer';
import { ISenderAccount } from '../../types';

export const selectSenderAccount = (state: RootState): ISenderAccount | null => state.senderAccounts.senderAccount;
export const selectVerifiedSenderAccounts = (state: RootState): ISenderAccount[] => state.senderAccounts.verifiedSenderAccounts;
export const selectSenderAccountLoading = (state: RootState): boolean => state.senderAccounts.loading;
export const selectSenderAccountError = (state: RootState): string | null => state.senderAccounts.error;
export const selectSenderAccountSuccess = (state: RootState): boolean => state.senderAccounts.success;